<div class="reader-container">
  <div
    mat-dialog-title
    class="modal-title"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <span class="modal-title-label">{{ httpService.getTransation().PatternReader }}</span>
    <button
      class="modal-close-button"
      mat-icon-button
      [matTooltip]="httpService.getTransation().Close"
      (click)="close()"
      tabindex="-1"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="reader-warning" *ngIf="!ttsSupported">
    {{ httpService.getTransation().ReaderTtsUnsupported }}
  </div>

  <div class="reader-controls">
    <div class="reader-controls-left">
      <div class="reader-progress">
        {{ httpService.getTransation().ReaderRow }} {{ getRowProgressLabel() }}
      </div>
    </div>
    <div class="reader-controls-center">
      <button
        mat-icon-button
        [matTooltip]="httpService.getTransation().ReaderReset"
        (click)="onReset()"
        [disabled]="currentRowIndex === 0"
        tabindex="-1"
      >
        <mat-icon>restart_alt</mat-icon>
      </button>
      <button
        mat-icon-button
        [matTooltip]="httpService.getTransation().Previous"
        (click)="onPrevSegment()"
        [disabled]="currentRowIndex === 0 && currentSegmentIndex <= 0"
        tabindex="-1"
      >
        <mat-icon>skip_previous</mat-icon>
      </button>
      <button
        mat-icon-button
        color="primary"
        class="reader-play"
        [matBadge]="getCountdownSeconds()"
        [matBadgeHidden]="waitCountdown <= 0"
        matBadgePosition="above after"
        matBadgeColor="warn"
        [matTooltip]="httpService.getTransation().ReaderPlay"
        (click)="onPlay()"
        *ngIf="!isPlaying || isPaused"
        [disabled]="!canPlay"
        tabindex="-1"
      >
        <mat-icon>play_arrow</mat-icon>
      </button>
      <button
        mat-icon-button
        color="primary"
        class="reader-play"
        [matBadge]="getCountdownSeconds()"
        [matBadgeHidden]="waitCountdown <= 0"
        matBadgePosition="above after"
        matBadgeColor="warn"
        [matTooltip]="httpService.getTransation().ReaderPause"
        (click)="onPause()"
        *ngIf="isPlaying && !isPaused"
        [disabled]="!canPlay"
        tabindex="-1"
      >
        <mat-icon>pause</mat-icon>
      </button>
      <button
        mat-icon-button
        color="warn"
        [matTooltip]="httpService.getTransation().ReaderStop"
        (click)="onStop()"
        [disabled]="!isPlaying && !isPaused"
        tabindex="-1"
      >
        <mat-icon>stop</mat-icon>
      </button>
      <button
        mat-icon-button
        [matTooltip]="httpService.getTransation().Next"
        (click)="onNextSegment()"
        [disabled]="currentRowIndex >= rows.length - 1 && currentSegmentIndex >= currentSegments.length - 1"
        tabindex="-1"
      >
        <mat-icon>skip_next</mat-icon>
      </button>
      <div class="reader-controls-divider" aria-hidden="true"></div>
    </div>
    <div class="reader-controls-right">
      <button
        mat-icon-button
        class="reader-header-icon"
        [matTooltip]="httpService.getTransation().ReaderColorLegend"
        (click)="openLegend()"
        tabindex="-1"
      >
        <mat-icon>palette</mat-icon>
      </button>
      <button
        mat-icon-button
        class="reader-header-icon"
        [matTooltip]="httpService.getTransation().ReaderSettings"
        (click)="openSettings()"
        tabindex="-1"
      >
        <mat-icon>tune</mat-icon>
      </button>
    </div>
  </div>

  <div class="reader-keyboard" *ngIf="rows.length > 0">
    {{ httpService.getTransation().ReaderKeyboardHint }}
  </div>

  <div class="reader-empty" *ngIf="rows.length === 0">
    {{ httpService.getTransation().ReaderNoRows }}
  </div>

  <div class="reader-rows" #rowsContainer *ngIf="rows.length > 0">
    <div class="reader-row" *ngFor="let row of rows; let rowIndex = index"
         [class.reader-row-active]="rowIndex === currentRowIndex"
         [attr.data-row-index]="rowIndex"
         #rowElement>
      <div class="reader-row-header" (click)="onRowHeaderClick(rowIndex)">
        <div class="reader-row-title">{{ row.rowHeader }}</div>
        <div class="reader-row-direction">
          <mat-icon *ngIf="row.direction === 'L'">arrow_left</mat-icon>
          <mat-icon *ngIf="row.direction === 'R'">arrow_right</mat-icon>
          <span>{{ row.direction }}</span>
        </div>
      </div>
      <div class="reader-row-segments">
        <button
          mat-stroked-button
          class="reader-segment"
          *ngFor="let segment of row.segments; let segIndex = index"
          [class.reader-segment-active]="isActiveSegment(rowIndex, segIndex)"
          (click)="onSegmentClick(rowIndex, segIndex)"
          #segmentElement
        >
          <div class="reader-bead-container">
            <div
              [class]="getBeadClasses(segment.paletteTypeId)"
              [ngStyle]="{ 'background-color': '#' + segment.beadColor }"
              [appBeadPreview]="segment"
              [previewPaletteId]="segment.paletteId"
            ></div>
            <div class="reader-bead-letter">{{ segment.letter }}</div>
          </div>
          <div class="reader-segment-count">{{ segment.count }}</div>
        </button>
      </div>
    </div>
    <div class="reader-preview-more" *ngIf="hiddenPreviewRowsCount > 0">
      <mat-icon>more_horiz</mat-icon>
      <span>{{ hiddenPreviewRowsCount }} more rows hidden</span>
    </div>
  </div>

  <div class="reader-preview-footer" *ngIf="isPreviewMode">
    <app-upgrade-preview-cta
      [title]="httpService.getTransation().ReaderPreviewTitle"
      [description]="httpService.getTransation().ReaderPreviewMessage"
      [hiddenRowsCount]="hiddenPreviewRowsCount"
      [buttonLabel]="httpService.getTransation().ReaderUpgradeCta"
      (ctaClick)="upgrade()"
    ></app-upgrade-preview-cta>
  </div>
</div>

<ng-template #legendTemplate>
  <div class="reader-dialog">
    <div mat-dialog-title class="modal-title">
      <span class="modal-title-label">{{ httpService.getTransation().ReaderColorLegend }}</span>
      <button
        class="modal-close-button"
        mat-icon-button
        [matTooltip]="httpService.getTransation().Close"
        (click)="closeLegend()"
        tabindex="-1"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div mat-dialog-content>
      <div class="reader-legend" *ngIf="legend.length > 0; else noLegend">
        <app-bead-list-item
          *ngFor="let entry of legend"
          [bead]="entry"
          [showLetter]="true"
          [showCount]="true"
          [showDescription]="false"
          beadSize="medium"
        ></app-bead-list-item>
      </div>
      <ng-template #noLegend>
        <div class="reader-empty">{{ httpService.getTransation().ReaderNoRows }}</div>
      </ng-template>
    </div>
  </div>
</ng-template>
